<template>
    <div>
        <button
            class="btn btn-md is-ghost hidden xl:inline-block"
            @click="$modal.show('create-empty-group')"
        >
            Skapa grupp
        </button>
        <button
            class="list-item xl:hidden"
            @click="$modal.show('create-empty-group')"
        >
            Skapa grupp
        </button>
        <adaptive-form-modal
            name="create-empty-group"
            primary-button-text="Skapa grupp"
            primary-button-class="is-primary"
            title="Skapa grupp"
            method="post"
            :action="route('api.sales-projects.groups.store', project)"
        >
            <group-form :types="types" />
        </adaptive-form-modal>
    </div>
</template>

<script>
    import GroupForm from './GroupForm';

    export default {
        components: { GroupForm },
        props: {
            project: {
                type: Object,
                required: true,
            },
            types: {
                type: Object,
                required: true,
            },
        },
    };
</script>
